const AnalysisStatus = {
    false: 'selfAssessment',
    true: 'measurement'
};

export default AnalysisStatus;
